"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_1 = require("crypto");
var TextUtils_1 = require("./TextUtils");
var Utils_1 = require("./Utils");
var Base64_1 = require("./Base64");
var HashUtils = /** @class */ (function () {
    function HashUtils() {
    }
    HashUtils.createHash = function (algorithm, encode, value) {
        if (TextUtils_1.default.isEmpty(value)) {
            return Utils_1.Utils.EMPTY_STRING;
        }
        if (TextUtils_1.default.isEmpty(algorithm)) {
            return Base64_1.default.encodeBytes(value);
        }
        if (TextUtils_1.default.isEmpty(encode) || "BASE64".compareToIgnoreCase(encode)) {
            return crypto_1.createHash(algorithm).update(value).digest("base64");
        }
        if ("hex".equals(encode)) {
            return crypto_1.createHash(algorithm).update(value).digest("hex").toLowerCase();
        }
        if ("HEX".equals(encode)) {
            return crypto_1.createHash(algorithm).update(value).digest("hex").toUpperCase();
        }
        return crypto_1.createHash(algorithm).update(value).digest("base64");
    };
    HashUtils.encodeHash = function (buff, encode) {
        if (buff == null || buff.length == 0) {
            return Utils_1.Utils.EMPTY_STRING;
        }
        if (TextUtils_1.default.isEmpty(encode) || "BASE64".compareToIgnoreCase(encode)) {
            return buff.toString('base64');
        }
        if ("hex".equals(encode)) {
            return buff.toString('hex').toLowerCase();
        }
        if ("HEX".equals(encode)) {
            return buff.toString('hex').toUpperCase();
        }
        return buff.toString('base64');
    };
    return HashUtils;
}());
exports.default = HashUtils;

//# sourceMappingURL=HashUtils.js.map
